export enum UserCustomFieldTypeDTO {
    CPF = "CPF",
    CNPJ = "CNPJ",
    Date = "Date",
    Number = "Number",
    Text = "Text",
    Phone = "Phone",
    File = "File",
    Select = "Select",
    MultiSelect = "MultiSelect",
    Address = "Address"
}
